import { buildTemplateValues }
  from "../../utils/templateVariables.js";

import { buildModulesTable }
  from "../../utils/templateProcessor.js";

export default function ContractPreview({
  contrato,
  template,
}) {
  console.log(contrato, "contrato");
  const values =
    buildTemplateValues(contrato);



  const html =
    buildModulesTable(
      template,
      values,
      contrato
    );

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
}